import { newToast } from '../components';
import useApi from '../utils/axios-pettitions';

export const useApiBilling = () => {
  const { runApi } = useApi();

  const getSimpleUsuarios = async () => {
    return runApi('Billing/GetSimpleUsuarios', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };
  
    const createFEV = async (idPreorder, observation) => {
    return runApi('Billing/CreateFEV', 'POST', {idPreorder, observation}, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const CreateRIPS = async (idPreorder) => {
    return runApi('Billing/CreateRIPS', 'POST', {idPreorder}, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  }

  return {
    getSimpleUsuarios,
    createFEV,
    CreateRIPS
  };
};
